
import "/app/src/components/Layout/SiderResizeHandle.module.less?modules";
export default {"boundary": `boundary-bJiB90RM`,"dark": `dark-LZiwJkvW`}
